import { createDeepEqualSelector } from 'utils/service/selectorUtils';
import { oc } from 'ts-optchain';

import * as Service from 'types/service';
import { StoreType } from '@tock/shared/utils/connect';
import { forEach } from 'es-toolkit/compat';
import { isEqual } from 'es-toolkit';

let existing: NumericDictionary<Service.PartyFromElm> | undefined = {};
export const elmPartiesSelector = createDeepEqualSelector(
  (state: StoreType) => oc(state).service.app.app.parties(),
  (
    parties?: NumericDictionary<Service.PartyFromElm>
  ): NumericDictionary<Service.PartyFromElm> | undefined => {
    if (parties && existing) {
      forEach(parties, (party) => {
        if (existing && existing[party.id] && isEqual(party, existing[party.id])) {
          parties[party.id] = existing[party.id];
        }
      });
    }
    existing = parties;
    return parties;
  }
);
